import React from 'react'
import { AppFC } from 'types'

import appDataPlaceholderChart1 from 'appAssets/appSvgs/appDataPlaceholderChart1.svg'
import appDataPlaceholderChart2 from 'appAssets/appSvgs/appDataPlaceholderChart2.svg'
import appDataPlaceholderChart3 from 'appAssets/appSvgs/appDataPlaceholderChart3.svg'
import appDataPlaceholderTexture from 'appAssets/appSvgs/appDataPlaceholderTexture.svg'

export const AppDataPlaceholderChart1: AppFC = () => {
  return <img src={appDataPlaceholderChart1} alt="app-data-placeholder-chart-1" />
}

export const AppDataPlaceholderChart2: AppFC = () => {
  return <img src={appDataPlaceholderChart2} alt="app-data-placeholder-chart-2" />
}

export const AppDataPlaceholderChart3: AppFC = () => {
  return <img src={appDataPlaceholderChart3} alt="app-data-placeholder-chart-3" />
}

export const AppDataPlaceholderTexture: AppFC = () => {
  return <img src={appDataPlaceholderTexture} alt="app-data-placeholder-texture" />
}

export const AppPlaceholderArt: AppFC = () => {
  return (
    <div className="relative flex justify-center items-center">
      <div className="flex justify-center items-center">
        <AppDataPlaceholderTexture />
      </div>
      <div className="grid grid-cols-3 gap-4 sm:gap-8 absolute">
        <div className="flex items-center justify-center">
          <AppDataPlaceholderChart1 />
        </div>
        <div className="flex items-center justify-center">
          <AppDataPlaceholderChart2 />
        </div>
        <div className="flex items-center justify-center">
          <AppDataPlaceholderChart3 />
        </div>
      </div>
    </div>
  )
}
